<template>
  <div class="link-cards-block py-3">
    <h2 v-if="block.value.heading" class="h4 mt-0 mb-3">{{ block.value.heading }}</h2>
    <div class="row g-3 row-cols-1 row-cols-md-2 row-cols-xl-3">
      <div v-for="(card, i) in cards" :key="i" class="col">
        <div class="link-card h-100">
          <div class="d-flex align-items-center gap-2 mb-3 text-primary">
            <Icon
              v-if="card.icon"
              :icon="`material-symbols:${card.icon}`"
              class="link-card-icon"
              :aria-hidden="true"
            />
            <h3 class="link-card-title m-0">{{ card.title }}</h3>
          </div>
          <ul class="list-unstyled m-0 d-flex flex-column gap-2">
            <li v-for="(link, j) in card.links" :key="j">
              <component
                :is="link.external_url ? 'a' : 'router-link'"
                :to="link.internal_page_url"
                :href="link.external_url || undefined"
                :target="link.external_url ? '_blank' : undefined"
                :rel="link.external_url ? 'noopener noreferrer' : undefined"
                class="link-card-link d-inline-flex align-items-center gap-1"
              >
                <span>{{ link.label }}</span>
                <Icon v-if="link.external_url" icon="material-symbols:open-in-new" />
              </component>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';

const {block} = defineProps<{block: SphereBlock<'link_cards_block'>}>();

// A link needs somewhere to go; skip the ones without.
const cards = computed(() =>
  block.value.cards.map((card) => ({
    ...card,
    links: card.links.filter((l) => l.external_url || l.internal_page_url),
  })),
);
</script>
<style lang="scss" scoped>
.link-card-icon {
  flex: none;
  font-size: 1rem;
}

.link-card-title {
  font-size: 0.875rem;
  font-weight: 600;
}

.link-card-link {
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
